import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { message } from 'antd';
import User from '../data/models/user';
import { can } from '../core/access';

// Every Excel export goes through these helpers, so the "Exportar a Excel" permission is
// enforced here once instead of on each screen's button.
const exportAllowed = () => {
    if (can(User.getInstance()?.userType, 'data.export')) return true;
    message.warning('No tienes permiso para exportar a Excel');
    return false;
};

export const downloadExcel = (columns, items, filename = 'data.xlsx') => {
    if (!exportAllowed()) return;
    if (!Array.isArray(columns) || !Array.isArray(items)) {
        console.error('Columns and items must be arrays');
        return;
    }

    // Create a new worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([columns, ...items.map((item) => columns.map((col) => item[col]))]);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Write and trigger the download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(excelBlob, filename);
};

// Multi-sheet export. `sheets` = [{ name, columns, items }] where items are objects keyed by column.
export const downloadExcelSheets = (sheets, filename = 'data.xlsx') => {
    if (!exportAllowed()) return;
    if (!Array.isArray(sheets) || !sheets.length) {
        console.error('sheets must be a non-empty array');
        return;
    }
    const workbook = XLSX.utils.book_new();
    sheets.forEach((s, i) => {
        const columns = s.columns || [];
        const items = s.items || [];
        const worksheet = XLSX.utils.aoa_to_sheet([columns, ...items.map((item) => columns.map((col) => item[col]))]);
        // Excel sheet names are max 31 chars and must be unique.
        const name = String(s.name || `Hoja ${i + 1}`).slice(0, 31);
        XLSX.utils.book_append_sheet(workbook, worksheet, name);
    });
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const excelBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(excelBlob, filename);
};
